/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsGenericList1MelcoModelsCategories,
    AssetsMelcoModelsGenericList1MelcoModelsCategoriesFromJSON,
    AssetsMelcoModelsGenericList1MelcoModelsCategoriesToJSON,
} from '../models';

export interface HoopsCategoriesApiCategoriesHoopsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
    categoryType?: string;
}

/**
 * 
 */
export class HoopsCategoriesApi extends runtime.BaseAPI {

    /**
     */
    async categoriesHoopsSearchRaw(requestParameters: HoopsCategoriesApiCategoriesHoopsSearchRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsGenericList1MelcoModelsCategories>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.categoryType !== undefined) {
            queryParameters['category_type'] = requestParameters.categoryType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/hoops/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsGenericList1MelcoModelsCategoriesFromJSON(jsonValue));
    }

    /**
     */
    async categoriesHoopsSearch(requestParameters: HoopsCategoriesApiCategoriesHoopsSearchRequest): Promise<AssetsMelcoModelsGenericList1MelcoModelsCategories> {
        const response = await this.categoriesHoopsSearchRaw(requestParameters);
        return await response.value();
    }

}
